import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetUserContactsRequest extends BaseServiceRequest {
    constructor(email) {
        super();
        super.addRequestUri("contacts.pb");
        super.addRequestParameter("email", email);
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.USER;
    }

    getMessageName() {
        return "UserContactsDataResponse";
    }
}

export default GetUserContactsRequest;